import { render, staticRenderFns } from "./PostEdit.vue?vue&type=template&id=b09b3a16&scoped=true"
import script from "./PostEdit.vue?vue&type=script&lang=js"
export * from "./PostEdit.vue?vue&type=script&lang=js"
import style0 from "./PostEdit.vue?vue&type=style&index=0&id=b09b3a16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09b3a16",
  null
  
)

export default component.exports